import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { ServiceCard } from "./ServiceCard";
import { Col, Row, Spinner } from "react-bootstrap";
import { DeleteModal } from "../Modals/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteService,
  serviceList,
  setserviceData,
} from "../../../redux/actions/dbactions/ServicesActions";

import { EditModal } from "./EditModal";
import { refTypesList } from "../../../redux/actions/dbactions/refactions";
import { AddModal } from "./AddModal";
import { getSession } from "../../../redux/actions/authActions";
import { Header } from "../../Header";
import FacilitiesIcon from "../../../../assets/FacilitiesIcon";

export const Services = () => {
  const [show, setShow] = useState(false);
  const [addmodal, setAddmodal] = useState(false);
  const [editmodal, setEditmodal] = useState(false);
  const { facilityId } = useParams();
  const { role_id } = getSession();
  const dispatch = useDispatch();
  const { service, isLoading } = useSelector((state) => state.serviceList);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    dispatch(serviceList(facilityId));
    dispatch(refTypesList());
  }, [facilityId, dispatch]);
  const handleShow = (svc_name, svc_id) => {
    setShow(true);
    setSelectedTitle(svc_name);
    setSelectedId(svc_id);
  };
  const handleEditModal = (data) => {
    setEditmodal(true);
    setRefresh(false);
    dispatch(setserviceData(data));
  };
  const handleDelete = () => {
    if (selectedId) {
      dispatch(deleteService(selectedId));

      setShow(false);
      setRefresh(true);
    }
  };
  useEffect(() => {
    if (refresh) {
      dispatch(serviceList(facilityId));
    }
  }, [dispatch, refresh, facilityId]);
  const serViceList = service.usr?.rec || [];
  return (
    <div>
      <Header
        pageTitle="Facilities & Services > Service List"
        icon={<FacilitiesIcon />}
      />

      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-nowrap">
          Services List
        </h5>

        <div className="w-fit whitespace-nowrap">
          <button
            onClick={() => setAddmodal(true)}
            className="sign_btn !text-sm"
          >
            + Add New Service
          </button>
        </div>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row className="sm:px-4 m-0">
        {serViceList.length > 0 ? (
          serViceList.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <ServiceCard
                data={item}
                handleShow={() => handleShow(item.svc_name, item.svc_id)}
                handleEditModal={handleEditModal}
                roleID={role_id}
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Services found</p>
          </Col>
        )}
      </Row>
      <DeleteModal
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
        handleDelete={handleDelete}
      />
      <AddModal
        show={addmodal}
        onHide={() => setAddmodal(false)}
        setRefresh={setRefresh}
        setAddmodal={setAddmodal}
        serviceid={facilityId}
      />
      <EditModal
        show={editmodal}
        onHide={() => setEditmodal(false)}
        setRefresh={setRefresh}
        setEditmodal={setEditmodal}
        serviceid={facilityId}
      />
    </div>
  );
};
